<template>
  <div>
    <!-- 定时任务调度日志列表对话框 -->
    <el-dialog
      :visible.sync="schedulerJobLogVisible"
      fullscreen
      :close-on-click-modal="false"
      @close="handleClose"
      class="scheduler-job-log-dialog">
      <div slot="title" class="dialog-title">调度日志</div>
      <div class="schedulerJobLog-page">
        <div class="back-bar">
          <el-button icon="el-icon-back" size="mini" @click="goBack">返回任务列表</el-button>
        </div>
        <div class="card-title" v-show="showSearch">
          <el-form size="small" label-width="68px" :model="queryParams" ref="queryForm">
            <el-row :gutter="48">
              <el-col :md="6" :sm="24">
                <el-form-item label="任务编号">
                  <el-input v-model="queryParams.jobId" class="search-item" placeholder="请输入任务编号" size="small" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6" :sm="24">
                <el-form-item label="任务名称">
                  <el-input v-model="queryParams.jobName" class="search-item" placeholder="请输入任务名称" size="small" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6" :sm="24">
                <el-form-item label="任务分组">
                  <el-input v-model="queryParams.jobGroup" class="search-item" placeholder="请输入任务分组" size="small" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6" :sm="24" v-if="advanced">
                <el-form-item label="任务状态">
                  <el-select v-model="queryParams.status" class="search-item" placeholder="请选择任务状态" clearable>
                    <el-option v-for="dict in dict.type.sys_job_status" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="6" :sm="24" v-if="advanced">
                <!-- 执行时间 -->
                <el-form-item label="执行时间" size="small">
                  <el-date-picker v-model="queryParams.dataRange" class="search-item" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 搜索按钮 -->
              <div class="search-content">
                <el-form-item class="search-button">
                  <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                  <el-button icon="el-icon-refresh" size="mini" @click="handleReset">重置</el-button>
                  <el-button type="text" :icon="advanced ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="advanced-button" @click="toggleAdvanced">
                    {{ advanced ? '关闭' : '展开' }}
                  </el-button>
                </el-form-item>
              </div>
            </el-row>
          </el-form>
        </div>

        <div class="card">
          <el-row :gutter="10" class="button-container">
            <el-col :span="1.5">
              <el-button type="success" icon="el-icon-edit" size="mini" plain :disabled="single" @click="handleUpdate">编辑</el-button>
            </el-col>
            <el-col :span="1.5">
              <el-button type="danger" icon="el-icon-delete" size="mini" plain :disabled="multiple" @click="handleDelete" :loading="buttonLoading">删除</el-button>
            </el-col>
            <right-toolbar :showSearch.sync="showSearch" :columns="columns" @getTableData="getTableData"></right-toolbar>
          </el-row>

          <el-table v-loading="loading" element-loading-text="正在加载表格数据" :data="tableData" @selection-change="handleSelectionChange" border>
            <template slot="empty">
              <el-empty :image-size="200"></el-empty>
            </template>
            <el-table-column type="selection" width="50" align="center" />
            <!-- 任务名称 -->
            <el-table-column prop="jobName" label="任务名称" align="center" v-if="columns[0].visible"></el-table-column>
            <!-- 任务分组 -->
            <el-table-column prop="jobGroup" label="任务分组" align="center" v-if="columns[1].visible"></el-table-column>
            <!-- 调用字符 -->
            <el-table-column prop="invokeTarget" label="调用字符" align="center" v-if="columns[2].visible"></el-table-column>
            <!-- 执行状态 -->
            <el-table-column prop="status" label="执行状态" align="center" v-if="columns[3].visible">
              <template slot-scope="scope">
                <el-tag type="primary" v-if="scope.row.status">成功</el-tag>
                <el-tag type="danger" v-else>失败</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="执行时间" align="center" v-if="columns[4].visible">
              <template slot-scope="scope">
                <span>{{ scope.row.createTime | dateFilter }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作"  align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" icon="el-icon-edit" @click="handleUpdate(scope.row)">编辑</el-button>
                <el-button type="text" size="small" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页器 -->
          <pagination :background="false" :total="total" :page.sync="queryParams.currentPage" :limit.sync="queryParams.pageSize" @pagination="getTableData" />
        </div>
      </div>
    </el-dialog>

    <!-- 定时任务调度日志信息编辑对话框 -->
    <el-dialog
      :title="schedulerJobLogTitle"
      width="500px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="editDialogVisible"
      @close="reset">
      <div class="schedulerJobLog-wrapper" v-loading="schedulerJobLogLoading" element-loading-text="正在加载定时任务调度日志信息">
        <el-form ref="schedulerJobLogForm" :model="formData" label-width="80px" label-position="right">
          <el-row :gutter="15">
            <!-- 调用字符 -->
            <el-form-item label="调用字符" prop="invokeTarget">
              <el-input v-model="formData.invokeTarget" placeholder="请输入调用字符" clearable></el-input>
            </el-form-item>
            <!-- 任务分组 -->
            <el-form-item label="任务分组" prop="jobGroup">
              <el-input v-model="formData.jobGroup" placeholder="请输入任务分组" clearable></el-input>
            </el-form-item>
            <!-- 任务信息 -->
            <el-form-item label="任务信息" prop="jobMessage">
              <el-input v-model="formData.jobMessage" placeholder="请输入任务信息" clearable></el-input>
            </el-form-item>
            <!-- 任务名称 -->
            <el-form-item label="任务名称" prop="jobName">
              <el-input v-model="formData.jobName" placeholder="请输入任务名称" clearable></el-input>
            </el-form-item>
            <!-- 执行状态 -->
            <el-form-item label="执行状态" prop="status">
              <el-input v-model="formData.status" placeholder="请输入执行状态" clearable></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="danger" :loading="buttonLoading" @click="editDialogVisible = false" size="small" icon="el-icon-error">
          取消
        </el-button>
        <el-button type="success" :loading="buttonLoading" @click="submitForm()" size="small" icon="el-icon-success">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '../../../../components/Pagination/index.vue'
import RightToolbar from '../../../../components/RightToolbar/index.vue'
import { listSchedulerJobLogs, getSchedulerJobLogById, deleteSchedulerJobLog } from '../../../../api/monitor/scheduler-job-log'

export default {
  name: 'SchedulerJobLog',

  components: { Pagination, RightToolbar },

  dicts: ['sys_job_status'],

  data () {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 是否展示搜索内容
      showSearch: true,
      // 数据总条数
      total: 0,
      // 定时任务调度日志列表对话框是否显示
      schedulerJobLogVisible: false,
      // 定时任务调度日志编辑对话框是否显示
      editDialogVisible: false,
      // 数据表格等待框
      loading: false,
      // 查询参数
      queryParams: {
        // 页数
        currentPage: 1,
        // 页面大小
        pageSize: 10,
        // 任务编号
        jobId: undefined,
        // 任务分组
        jobGroup: undefined,
        // 任务名称
        jobName: undefined,
        // 执行状态
        status: undefined,
        // 时间范围
        dataRange: []
      },
      // 定时任务调度日志表单对象
      formData: {
        // 任务编号
        jobId: undefined,
        // 调用字符
        invokeTarget: undefined,
        // 任务分组
        jobGroup: undefined,
        // 任务信息
        jobMessage: undefined,
        // 任务名称
        jobName: undefined,
        // 执行状态
        status: undefined
      },
      // 定时任务调度日志对话框等待框
      schedulerJobLogLoading: false,
      // 对话框按钮等待框
      buttonLoading: false,
      // 列信息
      columns: [
        // 任务名称
        { key: 0, label: '任务名称', visible: true },
        // 任务分组
        { key: 1, label: '任务分组', visible: true },
        // 调用字符
        { key: 2, label: '调用字符', visible: true },
        // 执行状态
        { key: 3, label: '执行状态', visible: true },
        { key: 4, label: '执行时间', visible: true }
      ],
      // 表格数据
      tableData: [],
      // 表头选中的数据
      ids: [],
      // 多数据禁用
      single: true,
      // 单数据禁用
      multiple: true,
      // 对话框标题
      schedulerJobLogTitle: ''
    }
  },

  methods: {
    // 返回（关闭对话框，由父组件控制显隐）
    goBack () {
      this.handleClose()
    },
    // 获取表格数据
    getTableData () {
      // 开启加载框
      this.loading = true
      listSchedulerJobLogs(this.queryParams).then((res) => {
        // 赋值数据参数
        this.tableData = res.list
        this.total = res.total
        // 关闭等待框
        this.loading = false
      }).catch(() => {
        // 确保加载框可以关闭
        this.loading = false
      })
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    handleQuery () {
      this.queryParams.currentPage = 1
      this.getTableData()
    },
    // 点击重置按钮
    handleReset () {
      // 任务编号
      this.queryParams.jobId = undefined
      // 任务分组
      this.queryParams.jobGroup = undefined
      // 任务名称
      this.queryParams.jobName = undefined
      // 执行状态
      this.queryParams.status = undefined
      this.queryParams.dataRange = []
    },
    // 打开定时任务调度日志信息对话框
    // @param jobId 任务编号，传 undefined / 'all' 表示查看全部任务日志
    handleOpen (jobId) {
      // 清除表单数据
      this.reset()
      // 根据传入的任务编号过滤（'all' 或不传则查全部）
      this.queryParams.jobId = (jobId && jobId !== 'all') ? jobId : undefined
      this.schedulerJobLogVisible = true
      // 查询表格数据
      this.getTableData()
    },
    // 关闭定时任务调度日志对话框表单
    handleClose () {
      this.reset()
      this.schedulerJobLogVisible = false
    },
    // 点击编辑按钮
    handleUpdate (row) {
      // 修改对话框标题
      this.schedulerJobLogTitle = '更新定时任务调度日志'
      // 获取到传来的ID
      const schedulerJobLogId = row.id || this.ids
      // 打开加载框
      this.schedulerJobLogLoading = true
      // 根据定时任务调度日志ID获取对应的数据
      getSchedulerJobLogById(schedulerJobLogId).then((res) => {
        // 赋值当前的定时任务调度日志数据
        this.formData = res
        // 打开编辑定时任务调度日志对话框
        this.editDialogVisible = true
        // 关闭加载框
        this.schedulerJobLogLoading = false
      }).catch(() => {
        // 关闭加载框
        this.schedulerJobLogLoading = false
      })
    },
    // 点击删除事件
    handleDelete (row) {
      const that = this
      let schedulerJobLogIds = []
      if (row.id) {
        schedulerJobLogIds.push(row.id)
      } else {
        schedulerJobLogIds = this.ids
      }
      this.$confirm('是否确认删除选中的定时任务调度日志数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.buttonLoading = true
        that.loading = true
        deleteSchedulerJobLog(schedulerJobLogIds).then((res) => {
          that.buttonLoading = false
          that.$message.success('删除成功')
          // 刷新数据
          that.getTableData()
        }).catch(() => {
          // 确保加载框会关闭
          that.buttonLoading = false
          that.loading = false
        })
      }).catch(() => {})
    },
    // 提交表单
    submitForm () {
      const that = this
      this.$refs.schedulerJobLogForm.validate(valid => {
        // 校验未通过则直接返回
        if (!valid) return
        // 开启加载框
        that.buttonLoading = true
        that.schedulerJobLogLoading = true
        // 关闭加载框
        // that.buttonLoading = false
        // that.schedulerJobLogLoading = false
      })
    },
    // 重置表单
    reset () {
      // 清除校验条件
      this.formData = {
        // 定时任务调度日志ID
        id: undefined,
        // 任务编号
        jobId: undefined,
        // 任务分组
        jobGroup: undefined,
        // 任务名称
        jobName: undefined,
        // 执行状态
        status: undefined
      }
      // 清除表单校验
      this.resetForm('schedulerJobLogForm')
    },
    // 多选框
    handleSelectionChange (selection) {
      // 获取当前选中数组的ID
      this.ids = selection.map(item => item.id)
      // 表头的编辑是否可以点击
      this.single = selection.length !== 1
      // 表头的删除是否可以点击
      this.multiple = !selection.length
    }
  }
}

</script>

<style lang="scss" scoped>
.back-bar {
  margin-bottom: 12px;
}
.schedulerJobLog-wrapper {
  padding: 10px 30px;
}
.schedulerJobLog-page {
  padding: 10px 20px;
}
.dialog-title {
  font-size: 16px;
  font-weight: 600;
}
</style>
<style lang="scss">
/* 全屏对话框内部布局：去掉默认内边距，让列表撑满 */
.scheduler-job-log-dialog .el-dialog__body {
  padding: 0;
}
</style>
